import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  UnorderedList,
  ListItem,
  Link,
} from '@chakra-ui/react';

const About = () => {
  return (
    <Container maxW="800px" py={10}>
      <VStack spacing={8} align="stretch">
        <Box>
          <Heading as="h1" size="xl" mb={4}>
            About NIH Termination Tracker
          </Heading>
          <Text fontSize="lg">
            This platform was created to gather information about recently terminated NIH-funded studies
            and to understand the impact these terminations have on the research community.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            Our Goals
          </Heading>
          <Text>
            The NIH Termination Tracker aims to:
          </Text>
          <UnorderedList mt={2} spacing={2} pl={4}>
            <ListItem>
              Document the scope and scale of recent NIH grant terminations
            </ListItem>
            <ListItem>
              Provide transparency about the types of research being affected
            </ListItem>
            <ListItem>
              Create a community resource for researchers experiencing similar situations
            </ListItem>
            <ListItem>
              Inform policy discussions with data about the impact of these decisions
            </ListItem>
          </UnorderedList>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            How It Works
          </Heading>
          <Text>
            Researchers who have received termination notices for their NIH-funded projects can
            submit information using our secure form. The information is stored in a database,
            and aggregated statistics are made available to help understand the broader impact
            of these terminations.
          </Text>
          <Text mt={4}>
            All personal information is optional, and researchers can choose to remain anonymous
            if they prefer. We take data privacy seriously and only collect information relevant
            to understanding the termination landscape.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            Get Involved
          </Heading>
          <Text>
            If you've received a termination notice for your NIH-funded project, please consider
            sharing your experience through our form. If you'd like to support this initiative or
            have questions, please reach out through our contact page.
          </Text>
          <Text mt={4}>
            This is a community initiative, and we welcome feedback and suggestions for how to
            improve this resource.
          </Text>
        </Box>
      </VStack>
    </Container>
  );
};

export default About;